export default "__VITE_ASSET__f08f4ff5__"